import { styled } from '@mui/material/styles';

import { Paper } from './Paper';

export const StepsPaper = styled(Paper)({
  padding: '28px 53px 51px 56px',
  alignSelf: 'start',
  position: 'relative',
});
